/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost } from '../fn/project-performance-indicator/api-performance-indicator-get-projects-performance-indicators-post';
import { ApiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost$Params } from '../fn/project-performance-indicator/api-performance-indicator-get-projects-performance-indicators-post';
import { apiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost$Plain } from '../fn/project-performance-indicator/api-performance-indicator-get-projects-performance-indicators-post-plain';
import { ApiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost$Plain$Params } from '../fn/project-performance-indicator/api-performance-indicator-get-projects-performance-indicators-post-plain';
import { GetPerformanceIndicatorsQueryResult } from '../models/get-performance-indicators-query-result';

@Injectable({ providedIn: 'root' })
export class ProjectPerformanceIndicatorService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost()` */
  static readonly ApiPerformanceIndicatorGetProjectsPerformanceIndicatorsPostPath = '/api/PerformanceIndicator/GetProjectsPerformanceIndicators';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost$Plain$Response(params?: ApiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPerformanceIndicatorsQueryResult>> {
    return apiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost$Plain(params?: ApiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost$Plain$Params, context?: HttpContext): Observable<GetPerformanceIndicatorsQueryResult> {
    return this.apiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPerformanceIndicatorsQueryResult>): GetPerformanceIndicatorsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost$Response(params?: ApiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPerformanceIndicatorsQueryResult>> {
    return apiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost(params?: ApiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost$Params, context?: HttpContext): Observable<GetPerformanceIndicatorsQueryResult> {
    return this.apiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPerformanceIndicatorsQueryResult>): GetPerformanceIndicatorsQueryResult => r.body)
    );
  }

}
